import Chart from 'chart.js';
import './style.scss'
let myChart = {}
let myChartCaseOverView = {}
let myloadChart = {}
var backgroundColor = []
export const random_rgba = () => {
    let o = Math.round,
        rand = Math.random,
        s = 255;
    let r = o(rand() * s);
    let g = o(rand() * s);
    let b = o(rand() * s);
    let a = 1;
    let ret = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
    if (r > 250 && g > 250 && b > 250) {
        ret = random_rgba();
    }
    return ret;
}

Chart.Chart.pluginService.register({
    beforeDraw: function (chart) {
        if (chart.config.type === "doughnut") {
            if (chart.config.centerText.display !== null &&
                typeof chart.config.centerText.display !== 'undefined' &&
                chart.config.centerText.display) {
                if (chart.config.labels[0].noOfTotalCases) {
                    chart.config.centerText.text = chart.config.labels[0].noOfTotalCases;
                }
                else if (chart.config.labels[0].totalNoOfCorrespondents) {
                    chart.config.centerText.text = chart.config.labels[0].totalNoOfCorrespondents
                }
                drawTotals(chart);
            }
        }
    }
});

function drawTotals(chart) {

    let width = chart.chart.width,
        height = chart.chart.height,
        ctx = chart.chart.ctx;

    ctx.restore();
    let fontSize = (height / 135).toFixed(2);
    ctx.font = fontSize + "em Verdana";

    ctx.textBaseline = "middle";
    ctx.lineWidth = 3;
    let text = chart.config.centerText.text,
        textX = Math.round((width - ctx.measureText(text).width) / 2),
        textY = height / 2;

    ctx.fillText(text, textX, textY);
    ctx.save();
}


const makeDatasetInfoForCaseOverviewResponse = (caseOverviewResponse) => {
    let results = [{
        data: [],
        backgroundColor: []
    }];
    results[0].data.push(caseOverviewResponse.noOfCompletedCases);
    results[0].data.push(caseOverviewResponse.noOfPendingCases);
    results[0].data.push(caseOverviewResponse.noOfWithdrawnCases);
    results[0].backgroundColor.push("#A3A0FA");
    results[0].backgroundColor.push("#54D8FE");
    results[0].backgroundColor.push('#7efde5');
    return results;
}

const makeDatasetInfoForCriticalCaseOverviewResponse = (criticalCaseOverviewResponse) => {
    let results = [{
        data: [],
        backgroundColor: []
    }];
    results[0].data.push(criticalCaseOverviewResponse.noOfCriticalCases);
    results[0].data.push(criticalCaseOverviewResponse.noOfExpiredCases);
    results[0].backgroundColor.push("#FE9D56");
    results[0].backgroundColor.push("#E94E3A");
    return results;
}


const makeDatasetInfoForCorrespondentLoadOverviewResponse = (param) => {
    let results = [{
        data: [],
        backgroundColor: [],
        name: [],
        id: []
    }];
    results[0].name = param.correspondentLoadInfoResponse ? param.correspondentLoadInfoResponse.map(element => {
        return element.correspondentInfoMetadata.name
    }) : [];
    results[0].id = param.correspondentLoadInfoResponse ? param.correspondentLoadInfoResponse.map(element => {
        return element.correspondentInfoMetadata.id
    }) : [];
    results[0].data = param.correspondentLoadInfoResponse ? param.correspondentLoadInfoResponse.map(element => {
        return element.noOfOfCases
    }) : [];
    results[0].backgroundColor = param.correspondentLoadInfoResponse ? param.correspondentLoadInfoResponse.map(element => {
        return random_rgba()
    }) : [];
    backgroundColor = results[0].backgroundColor
    return results;
}



export const makeChartInfoForCaseOverviewResponse = (caseOverviewResponse) => {
    if (myChartCaseOverView.chart != null)
        myChartCaseOverView.destroy()
    let ctx = document.getElementById("caseOverviewResponse").getContext('2d');
    let data1 = {};
    data1.datasets = makeDatasetInfoForCaseOverviewResponse(caseOverviewResponse);
    data1.datasets[0].borderWidth = 0
    myChartCaseOverView = new Chart(ctx, {
        type: 'doughnut',
        data: data1,
        labels: [caseOverviewResponse],
        options: {
            tooltips: {
                enabled: false
            },
            responsive: true,
            legend: {
                display: false,
            },
            legendCallback: function (chart) {
                let text = [];
                text.push('<div class="chart-legend d-flex flex-column w-20 pointer" indicator="in-progress"><span class="value mb-2 ml-4 pl-1" indicator="in-progress">' + chart.data.datasets[0].data[1] + '</span><div class="d-flex align-items-center" indicator="in-progress"><span class="indicator in-progress mr-2" indicator="in-progress"></span><label class="title mb-0" indicator="in-progress">In Progress</label></div></div><div class="chart-legend d-flex flex-column w-20 pointer" indicator="completed"><span class="value mb-2 ml-4 pl-1" indicator="completed">' + chart.data.datasets[0].data[0] + '</span><div class="d-flex align-items-center" indicator="completed"><span class="indicator finished mr-2" indicator="completed"></span><label class="title mb-0" indicator="completed">Completed</label></div></div><div class="chart-legend d-flex flex-column w-20 pointer" indicator="withdrawn"><span class="value mb-2 ml-4 pl-1" indicator="withdrawn">' + chart.data.datasets[0].data[2] + '</span><div class="d-flex align-items-center" indicator="withdrawn"><span class="indicator withdrawn mr-2" indicator="withdrawn"></span><label class="title mb-0" indicator="in-progress">Withdrawn</label></div></div>');
                return text.join('');
            }
        },
        centerText: {
            display: true,
            text: ''
        },
    })
    if (document.getElementById('chartjsLegendCaseOverviewResponse') != null) {
        document.getElementById('chartjsLegendCaseOverviewResponse').innerHTML = myChartCaseOverView.generateLegend();
    }
}

export const makeChartInfoForCriticalCaseOverviewResponse = (criticalCaseOverviewResponse) => {
    if (myChart.chart != null)
        myChart.destroy()
    let ctx = document.getElementById("criticalCaseOverviewResponse").getContext('2d');
    let data1 = {};
    data1.datasets = makeDatasetInfoForCriticalCaseOverviewResponse(criticalCaseOverviewResponse);
    data1.datasets[0].borderWidth = 0
    myChart = new Chart(ctx, {
        type: 'doughnut',
        data: data1,
        labels: [criticalCaseOverviewResponse],
        options: {
            tooltips: {
                enabled: false
            },
            responsive: true,
            legend: {
                display: false,
            },
            legendCallback: function (chart) {
                let text = [];
                text.push('<div class="chart-legend d-flex flex-column w-20 pointer" indicator="expired"><span class="value mb-2 ml-4 pl-1" indicator="expired">' + chart.data.datasets[0].data[1]
                    + '</span><div class="d-flex align-items-center" indicator="expired"><span class="indicator expired mr-2" indicator="expired"></span><label class="title mb-0" indicator="expired">Expired Cases</label></div></div><div class="chart-legend d-flex flex-column w-20 pointer" indicator="critical"><span class="value mb-2 ml-4 pl-1" indicator="critical">' + chart.data.datasets[0].data[0]
                    + '</span><div class="d-flex align-items-center" indicator="critical"><span class="indicator critical mr-2" indicator="critical"></span><label class="title mb-0" indicator="critical">Critical Cases</label></div></div>');

                return text.join('');
            }
        },
        centerText: {
            display: true,
            text: ''
        },
    })
    if (document.getElementById('chartjsLegendCriticalCaseOverviewResponse') != null) {
        document.getElementById('chartjsLegendCriticalCaseOverviewResponse').innerHTML = myChart.generateLegend();
    }
}

export const makeChartInfoForCorrespondentLoadOverviewResponse = (correspondentLoadOverviewResponse) => {
    if (myloadChart.chart != null)
        myloadChart.destroy()
    let ctx = document.getElementById("correspondentLoadOverviewResponse").getContext('2d');
    let data1 = {};
    data1.datasets = makeDatasetInfoForCorrespondentLoadOverviewResponse(correspondentLoadOverviewResponse);
    data1.datasets[0].borderWidth = 0
    myloadChart = new Chart(ctx, {
        type: 'doughnut',
        data: data1,
        labels: [
            correspondentLoadOverviewResponse
        ],
        options: {
            tooltips: {
                enabled: false
            },
            responsive: true,
            legend: {
                display: false,
            },
            legendCallback: function (chart) {
                let text;
                text = data1.datasets[0].data.map((val, index) => {
                    const style = 'style=border-color:' + data1.datasets[0].backgroundColor[index];
                    const indicator = 'indicator=' + data1.datasets[0].id[index]
                    return '<div class="chart-legend d-flex flex-column w-20 pointer"' + indicator + '><span class="value mb-2 ml-4 pl-1" ' + indicator + '>' + val
                        + '</span><div class="d-flex align-items-center" ' + indicator + '><span class="indicator expired mr-2"' + style + ' ' + indicator + '></span><label class="title mb-0" ' + indicator + '>' + data1.datasets[0].name[index] + '</label></div></div>'

                })

                return text.join('');
            }
        },
        centerText: {
            display: true,
            text: ''
        },
    });
    if (document.getElementById('chartjsLegendCorrespondentLoadOverviewResponse') != null) {
        document.getElementById('chartjsLegendCorrespondentLoadOverviewResponse').innerHTML = myloadChart.generateLegend();
    }

}

export const getTableData = (data, selected) => {
    let tableData = []
    if (selected) {
        data.forEach((val, index) => {
            if (val.correspondentId === selected) {
                tableData.push(val)
            }
        })
    }
    else {
        if (data.correspondentCaseLoadResponse) {
            data.correspondentCaseLoadResponse.forEach((val, index) => {
                val.correspondentLoadOverviewResponses.forEach((value) => {
                    let obj = Object.assign({ color: backgroundColor[index] }, value)
                    tableData.push(obj)
                })
            })
        }

    }
    return tableData
}